<template>
    <div>
        <!-- LV 13.11.2024: Wird durch "Ein Herz fürs Klima" ersetzt,
         was es nur bei Strom gibt, deshalb folgendes nur bei Gas (Commodity = 2) ausgeben -->
        <div class="options-intro" v-if="this.commodity === 2">
            <div class="oi-head">
                {{gruppe.name_extern}}
                <span
                    class="info-button"
                    data-trigger="hover"
                    data-container="body"
                    data-toggle="popover"
                    data-placement="top"
                    data-html="true"
                    v-if="gruppe.erklaerung_anzeigen"
                    :data-content="gruppe.erklaerung"></span>
            </div>

            <div class="oi-sub">{{gruppe.untertitel}}</div>
        </div>

        <div class="options-choose">

            <div class="form-check form-check-inline" v-for="(option, indexgrp) in gruppe.positionen"
                 :key="indexgrp">
                <input class="form-check-input"
                       :type="gruppe.logik === 0 ? 'radio' : 'checkbox'"
                       :name="`option_${id}_${gruppe.uid}_${option.uid}`"
                       :id="`option_${id}_${gruppe.uid}_${option.uid}`"
                       :value="option.betrag"
                       :checked="isChecked(option.betrag)"
                        @change="setValue(option.betrag)"
                       :tabindex="0"
                >
                <label class="form-check-label" :for="`option_${id}_${gruppe.uid}_${option.uid}`" v-html="option.name_extern"></label>
            </div>

        </div>
    </div>
</template>
<script>
export default {
    name: 'PreisoptionsGruppe',
    props: {
        gruppe: { type: Object, required: true },
        value: { type: Object, required: false, default: () => ({})},
        commodity: {
            type: Number,
            required: true
        },
    },
    mounted() {
        // Standardauswahl berücksichtigen
        if (this.gruppe.standard_position && this.groupValue === null) {
            this.setValue(this.gruppe.standard_position.betrag);
        }
    },
    computed: {
        groupValue() {
            return typeof this.value[this.gruppe.uid] !== 'undefined' ? this.value[this.gruppe.uid] : null;
        },
        id() {
          return (Math.random() * 10000) | 0;
        }
    },
    methods: {
        isChecked(optionsBetrag) {
            switch (this.gruppe.logik) {
                case 1: // UND
                    return this.isArray(this.groupValue) && this.groupValue.indexOf(optionsBetrag) !== -1;
                case 0: // ODER
                default:
                    return this.groupValue === optionsBetrag;
            }
        },
        setValue(newValue) {
            // ODER-Logik
            if (this.gruppe.logik === 0) {
                this.$emit('input', {
                    ...this.value,
                    [this.gruppe.uid]: newValue
                });
            } else {
                // UND-Logik (mehrere Werte möglich)
                if (this.isChecked(newValue)) {
                    const value = [...this.groupValue];
                    value.splice(value.indexOf(newValue), 1);
                    this.$emit('input', {
                        ...this.value,
                        [this.gruppe.uid]: value
                    });
                } else {
                    const value = this.isArray(this.groupValue) ? [...this.groupValue] : [];
                    value.push(newValue);
                    this.$emit('input', {
                        ...this.value,
                        [this.gruppe.uid]: value
                    });
                }
            }
        },
        isArray(array) {
            return typeof array === 'object' && array !== null && typeof array.length !== 'undefined';
        }
    }
}
</script>
